interface Step2Props {
  selected: string;
  onChange: (val: string) => void;
}

const HEDEF_KITLER = [
  { key: "tum-veliler", label: "Tüm Veliler", icon: "ri-group-line", count: 243, desc: "Tüm aktif ve yeni kayıt veliler", color: "border-[#0B1120] bg-[#0B1120]/5" },
  { key: "aktif-ogrenciler", label: "Aktif Öğrenciler", icon: "ri-user-star-line", count: 198, desc: "Devam eden öğrencilerin velileri", color: "border-emerald-400 bg-emerald-50" },
  { key: "referans-vermeyen", label: "Referans Vermeyen Veliler", icon: "ri-user-forbid-line", count: 126, desc: "Henüz referans vermemiş veliler", color: "border-red-300 bg-red-50" },
  { key: "referans-veren", label: "Referans Veren Veliler", icon: "ri-user-add-line", count: 72, desc: "Daha önce referans vermiş veliler", color: "border-violet-300 bg-violet-50" },
  { key: "yeni-kayitlar", label: "Yeni Kayıtlar", icon: "ri-user-received-line", count: 18, desc: "Son 30 gün içinde kayıt olanlar", color: "border-sky-300 bg-sky-50" },
  { key: "odeme-yaklaşan", label: "Ödeme Günü Yaklaşanlar", icon: "ri-calendar-check-line", count: 24, desc: "3 gün içinde ödeme günü gelenler", color: "border-amber-300 bg-amber-50" },
  { key: "taahhut-bitmek", label: "Taahhüdü Bitmek Üzere Olanlar", icon: "ri-file-warning-line", count: 11, desc: "30 gün içinde taahhüdü bitenler", color: "border-orange-300 bg-orange-50" },
  { key: "ozel-liste", label: "Özel Liste Yükle", icon: "ri-upload-cloud-line", count: null, desc: "CSV/Excel dosyasından liste yükleyin", color: "border-gray-300 bg-gray-50" },
];

export default function Step2HedefKitle({ selected, onChange }: Step2Props) {
  const selectedData = HEDEF_KITLER.find((h) => h.key === selected);

  return (
    <div className="space-y-5">
      <div>
        <h3 className="text-base font-bold text-gray-900 mb-1">Hedef Kitle Seçimi</h3>
        <p className="text-sm text-gray-500">Mesajınızı göndereceğiniz kitleyi seçin.</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {HEDEF_KITLER.map((h) => (
          <button
            key={h.key}
            onClick={() => onChange(h.key)}
            className={`text-left p-4 rounded-xl border-2 transition-all cursor-pointer group
              ${selected === h.key ? h.color + " shadow-sm" : "border-gray-100 bg-white hover:border-gray-200 hover:bg-gray-50"}
            `}
          >
            <div className="flex items-start gap-3">
              <div className={`w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0 transition-all
                ${selected === h.key ? "bg-[#0B1120] text-white" : "bg-gray-100 text-gray-500 group-hover:bg-gray-200"}
              `}>
                <i className={`${h.icon} text-base`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2">
                  <p className="text-sm font-semibold text-gray-800 leading-tight">{h.label}</p>
                  {h.count !== null && (
                    <span className={`text-xs font-bold px-2 py-0.5 rounded-full whitespace-nowrap
                      ${selected === h.key ? "bg-[#25D366] text-white" : "bg-gray-100 text-gray-600"}
                    `}>
                      {h.count}
                    </span>
                  )}
                </div>
                <p className="text-xs text-gray-500 mt-0.5 leading-relaxed">{h.desc}</p>
              </div>
            </div>
            {h.key === "ozel-liste" && selected === h.key && (
              <div className="mt-3 border-2 border-dashed border-gray-300 rounded-xl p-4 text-center">
                <div className="w-8 h-8 flex items-center justify-center mx-auto text-gray-400 mb-1">
                  <i className="ri-upload-cloud-2-line text-2xl"></i>
                </div>
                <p className="text-xs text-gray-500">CSV veya Excel dosyası sürükleyin veya seçin</p>
                <button className="mt-2 px-3 py-1 text-xs bg-gray-100 rounded-lg text-gray-600 hover:bg-gray-200 cursor-pointer transition-colors">
                  Dosya Seç
                </button>
              </div>
            )}
          </button>
        ))}
      </div>

      {selectedData && selectedData.count !== null && (
        <div className="flex items-center gap-3 p-4 bg-emerald-50 rounded-xl border border-emerald-200">
          <div className="w-8 h-8 flex items-center justify-center text-emerald-500">
            <i className="ri-checkbox-circle-line text-xl"></i>
          </div>
          <p className="text-sm font-semibold text-emerald-700">
            Seçilen hedef kitle: <strong>{selectedData.count} kişi</strong>
          </p>
          <p className="text-xs text-emerald-600 ml-auto hidden sm:block">
            Tahmini süre: ~{Math.ceil(selectedData.count * 6 / 60)} saat
          </p>
        </div>
      )}
    </div>
  );
}